import { HHStack, HHTypography } from '@hinge-health/react-component-library';

interface SubmissionCellProps {
  submissionDate: string;
  submissionAmount: number;
}
export const SubmissionCell = ({
  submissionDate,
  submissionAmount,
}: SubmissionCellProps): JSX.Element => (
  <HHStack direction="column">
    <HHTypography hhVariant="caption">{submissionDate || '--'}</HHTypography>
    <HHTypography hhVariant="caption">{submissionAmount || '--'}</HHTypography>
  </HHStack>
);
